module.exports = __webpack_public_path__ + "static/media/single-cube.d354dcac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/single-cube.png
// module id = 1763
// module chunks = 0